import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { type FC, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

type Props = {
  fileUrl: string;
  height?: number;
  width?: number;
};

const options = {
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
  standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts`
};

const PdfViewer: FC<Props> = ({ fileUrl, height, width = 800 }) => {
  const [numPages, setNumPages] = useState<number>(0);

  return (
    <div>
      <Document
        file={fileUrl}
        onLoadSuccess={(document: { numPages: number }) => setNumPages(document.numPages)}
        options={options}
      >
        {Array.from(new Array(numPages), (_, index) => (
          <Page
            key={`page_${index + 1}`}
            height={height}
            pageNumber={index + 1}
            renderAnnotationLayer={true}
            renderTextLayer={true}
            width={width}
          />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;
